const anime = require('anime')

class AnimationsPlayer {
  constructor($el, keyframes) {
    this.$el = $el
    this.keyframes = keyframes
  }

  init() {}
  dispose() {}
  seek() {}
}

class WebAnimationsPlayer extends AnimationsPlayer {
  init() {
    if (this.player) this.player.cancel()

    this.player = this.$el[0].animate(this.keyframes, { duration: 1, fill: 'forwards' })
    this.player.pause()
  }

  dispose() {
    if (this.player) this.player.cancel()
  }

  seek(progress) {
    if (this.player) this.player.currentTime = progress
  }
}

const MAX_FRAMES_LENGTH = 1000

class SvgAnimationsPlayer extends AnimationsPlayer {
  init() {
    if (this.player) anime.remove(this.$el[0])

    this.$el.attr(this.keyframes[0])
    this.player = anime({
      targets: this.$el[0],
      ...this.animeKeyframes,
      duration: MAX_FRAMES_LENGTH,
      autoplay: false,
      easing: 'linear',
    })
  }

  get animeKeyframes() {
    let result = {}
    let lastFrameDurationPercentage = 0

    this.keyframes.slice(1).forEach(frame => {
      Object.keys(frame)
        .filter(key => key !== 'offset')
        .forEach(prop => {
          result[prop] = result[prop] || []

          result[prop].push({
            value: frame[prop],
            delay: 0,
            duration: MAX_FRAMES_LENGTH * (frame.offset - lastFrameDurationPercentage)
          })
        })

        lastFrameDurationPercentage = frame.offset
      })

    return result
  }

  dispose() {
    anime.remove(this.$el[0])
  }

  seek(progress) {
    if (1 - progress <= 0.011) progress = 1 // HACK: compensate 0.99 hack from web animations

    if (this.player) this.player.seek(progress * 1000)
  }
}

AnimationsPlayer.for = ($el, keyframes) => {
  if ($el.is('path, circle, line') || $el.parent().is('svg')) {
    return new SvgAnimationsPlayer($el, keyframes)
  }

  return new WebAnimationsPlayer($el, keyframes)
}

module.exports = AnimationsPlayer
